export default __webpack_public_path__ + "static/media/Gizmosity.a3fd52d2.png";